export { default } from './GeneralNotify';